import { Button as AntButton, Modal } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { updateStudentMemo } from "../../../../api/studentsMemos.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import { IStudentMemo } from "../../../../models/studentsMemos.model";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  record: IStudentMemo|undefined;
  doGetStudentMemos: () => void;
}

const EditMemoModal: FC<IProps> = ({
  visible,
  setVisible,
  record,
  doGetStudentMemos,
}) => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const [memo, setMemo] = useState('');

  useEffect(() => {
    if (record) {
      setMemo(record.memo);
    }
  }, [record]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetStudentMemos();
      successNotification(t('common.message.edit1'));
      onClose();
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    if (!record) return;
    if (!memo) {
      return infoNotification(t('student.student.message45'));
    }

    submitExecute(updateStudentMemo(record.memberCode, {
      memoCode: record.memoCode,
      memo,
    }));
  }

  const onClose = () => {
    setMemo('');
    setVisible(false);
  }

  return (
    <>
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />

      <Modal
        title={t('student.student.title19')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' type="primary" onClick={onSubmit}>
              {t('common.button.edit')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <input
          type="text"
          className="form-control input-text"
          value={memo}
          onChange={e => setMemo(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter') onSubmit();
          }}
        />      
      </Modal>
    </>
  );
}

export default EditMemoModal;
